import api from "./api";
import auth from "./auth";

export default {
    getList(param) {
        return new Promise((resolve, reject) => {
            api.get(
                "achievement-service/achievement-unlock-config/list/" + param,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getTargetSegmentOptions() {
        return new Promise((resolve, reject) => {
            api.get(
                "target-segment-service/target-segment/module-options",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    updateAchievement(detail) {
        return new Promise((resolve, reject) => {
            api.post(
                "achievement-service/achievement-unlock-config/update/" +
                    detail.uuid,
                detail,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getWelcomeDiscountDetails() {
        return new Promise((resolve, reject) => {
            api.get(
                "achievement-service/v1/cms/dine-in/welcome-promo-code/details",
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    saveWelcomeDiscountDetails(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                "achievement-service/v1/cms/dine-in/welcome-promo-code/save",
                payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
